import store from "../../store";

export default {
    props: {
        index: {
            type: Number,
            required: true
        }
    },
    computed: {
        value: {
            get() {
                return this.store.stages[this.index].value
            }
        },
        store() {
            return store
        },
    }
}
